import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import PageContent from "@my-dld/components/PageContent";

interface State {

}

class NewRequest extends Component<any, State> {
	constructor( props: any ) {
		super( props );
		this.state = {};
	}

	render() {
		return <PageContent title={ "Add New Request" }>
			<PageTitle title={ "Add New Request" } paths={ [ DashboardBCItem ] }/>
			<div className="row">
				<div className="col-md-6">
					<div className="form-group field-style select-control">
						<label>Please select your Request</label>
						<select className="form-control">
							<option>Select</option>
							<option>Option1</option>
							<option>Option2</option>
							<option>Option3</option>
						</select>
					</div>
				</div>
			</div>
			<div className="form-group">
				<h5>Service Description</h5>
				This service allows clients to apply for issuing a Statement of Customer Property or a Certificate of Satisfaction of Property
				Management Requirements.
			</div>
			<div className="form-group mt-3">
				<button
					className="btn btn_1 btn_style1" type="submit" id="btnContinue"
					onClick={ this.onContinue }>{ Strings.continue }</button>
				<a className="ms-3" onClick={ this.props.history.goBack }>{ Strings.cancel }</a>
			</div>
		</PageContent>;
	}

	private onContinue = () => {

	};


}

export default NewRequest;
